import React, { useState } from "react";
import PropTypes from "prop-types";
import { useController } from "@rest-hooks/react";

import OrderSummary from "components/OrderSummary";

import Footer from "../Footer";

import { findOrderResult } from "utils/profile/claim/findOrderInstance";
import { useError } from "utils/useErrorController";

import { t } from "i18n/index";
import {PaymentElement, useStripe, useElements, } from "@stripe/react-stripe-js";

/** CONSTANTS **/
const paymentElementOptions = { layout: "tabs" };

/** COMPONENT **/
const Form = ({
  items,
  onStepChange,
  onContentChange,
  onShowTickets,
 }) => {
  const [isElementsReady, setIsElementsReady] = useState(false);

  const { handleError, setLoading } = useError();
  const { fetch }                   = useController();
  const stripe                      = useStripe();
  const elements                    = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!stripe || !elements || !isElementsReady) {
      setLoading(false);
      handleError(t("errors:stripeNotReady"));
      return;
    }

    try {
      const response = await stripe.confirmPayment({ elements, confirmParams: {}, redirect: "if_required" });

      if (!response.error) {
          findOrderResult( response.paymentIntent.id, fetch, onStepChange, handleError, setLoading, onContentChange, onShowTickets );

      } else {
        handleError(response.error?.message || t("errors:default"));
      }
    } catch (error) {
      handleError(error);
    }
  };

  const firstProduct = items[0]?.product;
  const currency = firstProduct?.organization?.currency;
  const frequency = items[0]?.frequency ?? "lifetime";

  return (
    <form onSubmit={handleSubmit} className='payment-form'>
      <PaymentElement options={paymentElementOptions} onReady={() => setIsElementsReady(true)}/>

      <div className="content">
        <OrderSummary
          items={items}
          frequency={frequency}
        />

        <Footer
          itemPrice={firstProduct?.unit_price}
          object={firstProduct}
          disabled={!stripe || !elements || !isElementsReady}
          caller="stripe"
          frequency={frequency}
          currency={currency}
        />
      </div>
    </form>
  );
};

Form.propTypes = {
  items: PropTypes.array.isRequired,
  onStepChange: PropTypes.func,
  onShowTickets: PropTypes.func,
  onContentChange: PropTypes.func,
};

export default Form;
